export const ATTRIBUTES = {
  fields: {
    preset: 'preset',
    answersCount: 'answer_count',
    layoutType: 'layout',
    answerItems: 'answer_items',
    withNeutralAnswer: 'with_neutral_answer',
    withZeroValueAnswer: 'with_zero_weight_answer',
    withAdditionalFeedback: 'feedback_field',
    withTextReplyQuestions: 'text_reply_questions',
  },
  verticalLayout: 'VERTICAL',
  horizontalLayout: 'HORIZONTAL',
  answerStyle: {
    textBox: 'TEXT',
    scale: 'SCALE',
  },
  minAnswers: 2,
  maxAnswers: 15,
  answersBreakpoint: 6,
  fieldsStyleOptions: {
    increaseAnswersCount: 'increaseAnswersCount',
    decreaseAnswersCount: 'decreaseAnswersCount',
    toOpenEndedQuestions: 'toOpenEndedQuestions',
    toMultipleChoiceQuestions: 'toMultipleChoiceQuestions',
    addNeutralAnswer: 'addNeutralAnswer',
    removeNeutralAnswer: 'removeNeutralAnswer',
    addAdditionalFeedback: 'addAdditionalFeedback',
    removeAdditionalFeedback: 'removeAdditionalFeedback',
  },
};

export const PLACEHOLDER_ATTRIBUTE = {
  selfScore: '/',
  scoreByOthers: '/',
  max_score: 10,
};

export const SKILLS_MATRIX_ATTRIBUTE_CONFIG = {
  MIN: 1,
  DEFAULT: 10,
  MAX: 30,
};

export const COMPETENCE_MAP_ATTRIBUTE_CONFIG = {
  DEFAULT: 3,
  MIN: 1,
  MAX: 5,
};

export const PEOPLE_INSIGHTS_ATTRIBUTE_CONFIG = {
  DEFAULT: 3,
  MIN: 1,
  MAX: 30,
};

export const ATTRIBUTE_VIEW_OPTIONS = [
  {
    value: true,
    name: 'Active',
    key: 'active',
  },
  {
    value: false,
    name: 'Inactive',
    key: 'inactive',
  },
];
